const { fixedEncodeURIComponent } = require('../utils/utils')

module.exports = function (sparql) {
  const query = fixedEncodeURIComponent(sparql)
  return `https://query.wikidata.org/sparql?format=json&query=${query}`
}



//////////////////
// WEBPACK FOOTER
// ./~/wikidata-sdk/lib/queries/sparql_query.js
// module id = 80
// module chunks = 0